import { useChannelSync } from "hooks/useChannelUpdates";

function ChannelSyncActivator() {
  useChannelSync();
  return null;
}

export default ChannelSyncActivator;
